/**
 * Placeholder stack shown while a feed query is in flight. Pills cascade in
 * with the same motion as real cards so a filter toggle feels like a load,
 * then the live list replaces this once the matching response arrives.
 */
import { cn } from "@/lib/utils";

const PAGE_PILL_COUNT = 6;
const COMPACT_PILL_COUNT = 4;
const PILL_STAGGER_MS = 48;

export function FeedListLoading({
  compact = false,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  const count = compact ? COMPACT_PILL_COUNT : PAGE_PILL_COUNT;
  return (
    <div
      className={cn(
        "feed-list-loading feed-event-list flex w-full min-w-0 flex-col",
        compact ? "gap-2" : "gap-[var(--shell-gap)]",
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading feed"
    >
      <span className="sr-only">Loading feed…</span>
      <div className="feed-row-stack min-w-0">
        {Array.from({ length: count }, (_, index) => (
          <div
            key={index}
            className="feed-row-slot"
            style={{
              animationDelay: `${Math.min(index, 10) * PILL_STAGGER_MS}ms`,
            }}
          >
            <div className="feed-row-slot__clip">
              <div
                className={cn(
                  "feed-list-loading__pill glass-pill clay",
                  compact && "feed-list-loading__pill--compact",
                )}
                style={{
                  animationDelay: `${Math.min(index, 10) * PILL_STAGGER_MS}ms`,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
